import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100vh;
  padding: 15px;
`

export const Section = styled.section`
  width: 100%;

  display: flex;
  align-items: flex-end;
  margin-bottom: 25px;
`

export const Center = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex: 1;
`

export const CenterLoading = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  overflow-y: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    font-size: 26px;
    margin-top: 10px;
  }
`

export const SectionTerms = styled.div`
  flex: 1;
  display: flex;
  gap: 15px;
  align-items: flex-end;
`

export const Article = styled.article``

export const Buttons = styled.div`
  width: 300px;
  display: flex;
  justify-content: center;
`

export const CondicaoPagamento = styled.div`
  margin: 50px 0;
`
export const Title = styled.h1`
  font-size: 25px;
  margin-bottom: 20px;
`

export const ResultsCustomers = styled.div`
  width: 50%;
  height: auto;
  max-height: 250px;
  overflow-y: scroll;
  margin-bottom: 10px;

  display: flex;
  flex-direction: column;
  gap: 10px;

  article {
    background: #cecece;
    padding: 5px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    cursor: pointer;
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }

    h1 {
      all: unset;
      font-size: 16px;
      font-weight: bold;
    }

    p {
      all: unset;
      font-size: 14px;
    }
  }
`

export const ResultsProducts = styled.div`
  width: 100%;
  height: auto;
  overflow-y: scroll;
  margin: 10px 0;

  display: flex;
  flex-direction: column;
  gap: 10px;

  article {
    background: #cecece;
    padding: 5px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    cursor: pointer;
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }

    h1 {
      all: unset;
      font-size: 16px;
      font-weight: bold;
    }

    p {
      all: unset;
      font-size: 14px;
    }
  }
`
export const Fixed = styled.div`
  height: 50px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  align-items: center;
  justify-content: flex-end;
`
